// extracted by mini-css-extract-plugin
module.exports = {"shopCartIcon":"cart-btn_shopCartIcon_IA7IO","nogoodscart":"cart-btn_nogoodscart_1cCEj","region-btn":"cart-btn_region-btn_3w645"};